import { Image } from '@/components/Image';
import { Data } from '@/types/content';
import { generateImageSrc } from 'base/components/labrador/LabradorImage/compute';
import { MostReadSlide } from 'base/components/MostRead';

interface ImageConfig {
  maxWidth?: number;
  minWidth?: number;
}

export const mapArticlesDataToSlides = (articles: Data[], imageConfig?: ImageConfig) => {
  return articles.reduce<MostReadSlide[]>((result, article) => {
    if (!article.image) return result;

    const imageSrc = generateImageSrc({
      filename: article.image,
      imageData: { imageId: article.image },
      isPreview: false,
      maxWidth: imageConfig?.maxWidth ?? 600,
      minWidth: imageConfig?.minWidth ?? 300,
    });

    return [
      ...result,
      {
        caption: article.prominentTag || article.section_tag,
        description: article.title,
        publishedUrl: article.published_url,
        image: <Image src={imageSrc?.href} />,
      },
    ];
  }, []);
};
